// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"535":"login","940":"request"}[chunkId] + "." + {"535":"7ce0e274","940":"6ed0d9eb"}[chunkId] + ".css";
};